const UnlockButton = ({ onClickHandler }: { onClickHandler: Function }) => {
  return (
    <button onClick={() => onClickHandler()} className="unlockbutton">
      Freischalten
    </button>
  );
};

export default UnlockButton;
